export default __webpack_public_path__ + "static/media/upLeftArrowHover.5868caca.png";